import { BoardCardType } from "@fry/boards/lib";
import { WalkthroughsCardViewComponent } from "./walkthroughs-card.view.component";
import { TitleCardSettingsComponent } from "@fry/dashboards/components/card-title-settings/title-card.settings.component";

export const WalkthroughsCard: BoardCardType = {
    name: 'walkthroughs',
    title: $localize `Walkthroughs`,
    viewComponent: WalkthroughsCardViewComponent,
    editComponent: TitleCardSettingsComponent,
}
